import { render, staticRenderFns } from "./BaseSlider.vue?vue&type=template&id=2484a38b&scoped=true"
import script from "./BaseSlider.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSlider.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseSlider.vue?vue&type=style&index=0&id=2484a38b&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2484a38b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2484a38b')) {
      api.createRecord('2484a38b', component.options)
    } else {
      api.reload('2484a38b', component.options)
    }
    module.hot.accept("./BaseSlider.vue?vue&type=template&id=2484a38b&scoped=true", function () {
      api.rerender('2484a38b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/ui/atoms/baseSlider/BaseSlider.vue"
export default component.exports